// import { connect } from 'react-redux';
import React from 'react';
import connectStore from 'decorators/connectStore';
import provideTranslations from 'decorators/provideTranslations';
import SitewideNotificationStore from 'stores/SitewideNotificationStore';
import SitewideNotification from './SitewideNotification';

// const mapStateToProps = state => {
//   let sitewideNotificationId = '';
//   let strings = {};

//   sitewideNotificationId = state.sitewideNotificationId;
//   strings = state.i18n.strings;

//   return {
//     message: strings[sitewideNotificationId],
//   };
// };

// export default connect(mapStateToProps)(SitewideNotification);

// @TODO AUTHOR-10826: Replace Alt with Redux
@provideTranslations('core')
@connectStore(SitewideNotificationStore, 'sitewideNotificationState')
class ConnectedSitewideNotification extends React.Component {
  render() {
    return (<SitewideNotification {...this.props} />);
  }
}

export default ConnectedSitewideNotification;
